/**
 * The "Applied for" label in Applicant History.
 *
 * An archived application has no listing left to read a title from — deleting
 * that listing is what archived it. `rental_leads.pipeline_property_id`
 * survives the delete (20260814000100_rental_leads_survive_listing_delete),
 * so the property it points at is the only thing left that can name what the
 * applicant applied for — and the listing title was seeded from that address
 * to begin with, so the two read the same.
 */

/** The slice of `pipeline_properties.property_data` this label reads. */
export interface AppliedForPropertyData {
  address?: string | null;
  /** Rows cached before `address` was the norm carry `street_address`. */
  street_address?: string | null;
}

/**
 * Address of the property an application was made against, or `null` when it
 * can't be named — the deal was dropped from the pipeline (the FK is
 * ON DELETE SET NULL, so the lead survives with no property) or the cached row
 * carries no address at all.
 * Pure for testing.
 */
export function appliedForLabel(
  propData: AppliedForPropertyData | null | undefined,
): string | null {
  const address = propData?.address?.trim() || propData?.street_address?.trim();
  return address || null;
}
